import React, { memo } from 'react';

const Button = (props) => (
  <button {...props}>
    {props.isloading ? <i className="fas fa-spinner fa-spin"></i> : props.title}
  </button>
);

export default memo(Button);
